export default {

  methods: {

    set_LocalValues(){

      this.chartData = JSON.parse(JSON.stringify(this.DataItems))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      // JQueries
      this.radio      = json.radio
      this.title      = json.title
      this.timeline   = json.timeline
      this.primary    = json.primary
      this.secondary  = json.secondary
      this.grid       = json.grid
      this.chart      = json.chart
      this.table      = json.table
      this.legends    = json.legends

      this.keys       = json.keys
      this.filter     = json.filter
      this.sundries   = json.sundries

      
       // Table
      this.table.height = this.chart.styles.filter(f=> f.tbl == 'Y').length * this.table.lineHeight

      // set Current
      this.chartIdx   = json.chartIdx ? json.chartIdx : 1
      this.current = this.radio.list[0]
      if(this.getSelectItems) {
        this.getItems = JSON.parse(this.getSelectItems)
        this.current = this.getItems[`current${this.chartIdx}`] ? this.getItems[`current${this.chartIdx}`] : this.radio.list[0]
      }


      this.chart.styles = this.legends.reverse == 'Y' ? this.chart.styles.reverse() : this.chart.styles
    },


  }
}